module.exports = __webpack_public_path__ + "img/portrait_phone1.7f82fcad.png";